<template>

  <WindowForAlert :id="'chooseStation'"
                  :title="getLanguageStr('phrase976','请选择系统')"
                  ref="chooseStation"
                  :size="'m'">
    <div class='chooseStation' scroll>
      <ul>
        <li v-for='item in list' :key='item.siteId'>
          <div class='chosee' >
            <MyRadio class="dpIB mr2x "
                     name="siteId"
                     v-model="siteId"
                     :label="item.siteId"></MyRadio>
          </div>
          <div>{{item.siteName}}</div>
        </li>
      </ul>
    </div>
    <button slot="btmBtn"
            class="functionBtn"
            @click="openView"
            :title="$t('cmd12',['确定'])"
            type="button">{{$t('cmd12',['确定'])}}</button>
  </WindowForAlert>

</template>
<script>
import WindowForAlert from '@/components/common/ui/WindowForAlert.vue'
import Select from '@/components/common/ui/Select.vue'
import InputText from '@/components/common/ui/InputText.vue'
import * as lib from '@/util/lib.js'
import { getLanguageStr } from '@/util/language.js'
import { getStationList } from '@/api/device/device/device.js'
import MyRadio from '@/components/common/ui/Radio'

export default {
  components: { Select, WindowForAlert, InputText, MyRadio },
  props: {
  },
  data () {
    return {
      siteId: '',
      alldata: {},
      list: []
    }
  },
  computed: {
  },
  watch: {
  },
  mounted () {
    lib.setScroll($(this.$el).find('[scroll]'))
  },
  methods: {
    getTypeText: lib.getTypeText,
    getLanguageStr,
    show (device) {
      this.alldata = device
      getStationList({deviceId: device.deviceId, parDeviceId: device.parDeviceId, deviceSn: device.deviceSn, activationState: device.activationState, deviceType: device.deviceType}).then(data => {
        if (data.length === 1) {
          this.$emit('openView', {
            'deviceId': device.deviceId,
            'deviceSn': device.deviceSn,
            'siteId': data[0].siteId
          })

          return false
        }
        // data.push(data[0])
        this.$refs.chooseStation.show()
        this.siteId = data[0].siteId
        this.list = data
        this.$nextTick(_ => {
          lib.setScroll($(this.$el).find('[scroll]'))
        })
      }).catch(error => {
        !_.isEmpty(error) && this.$notify(error)
      })
    },
    openView () {
      this.$emit('openView', {
        'deviceId': this.alldata.deviceId,
        'deviceSn': this.alldata.deviceSn,
        'siteId': this.siteId
      })
      this.$refs.chooseStation.hide()
    },
    reset () {

    },
    getList () {

    },
    hide () {

    }
  }
}
</script>
<style lang="scss" scoped>
.chooseStation {
  max-height: 20rem;
  ul {
    li {
      display: flex;
      height: 40px;
      flex-direction: row;
      border-bottom: 1px solid #dfdfdf;
      align-items: center;
      .chosee {
        width: 5rem;
        padding-top: 8px;
      }
    }
  }
}
</style>



// WEBPACK FOOTER //
// src/view/device/device/part/ChooseStation.vue